import Auth from "../views/Auth";
import AuthLogin from "../views/AuthLogin";
import AuthForgottenPassword from "../views/AuthForgottenPassword";
export default {
  path: "/login",
  component: Auth,
  children: [
    {
      path: "",
      name: "auth-login",
      component: AuthLogin,
      beforeEnter(to, from, next) {
        if (localStorage.getItem("authToken")) {
          return next({ name: "dashboard" });
        }
        return next();
      }
    },
    {
      path: "esqueci-minha-senha",
      name: "auth-forgotten-password",
      component: AuthForgottenPassword
    }
  ]
};
